/**
 * cart-drawer-a11y.js — Mercy Oil
 * Additive accessibility for the cart drawer. Does NOT rebuild open/close:
 *   - Escape closes (reuses the existing <side-panel-close>).
 *   - Focus trapped inside while open.
 *   - Focus returned to the cart icon (#cart-drawer-toggle) on close.
 */
(function () {
  'use strict';

  function drawer() { return document.querySelector('.cart-drawer.side-panel'); }
  function isOpen(d) { return d && d.classList.contains('active'); }
  function focusables(d) {
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(d.querySelectorAll(sel), function (el) {
      return el.offsetParent !== null;
    });
  }

  var lastFocus = null;

  // Remember the cart icon when the drawer opens, and move focus into the
  // drawer so keyboard/screen-reader users land inside it (was never focused).
  document.addEventListener('cart-drawer:open', function () {
    lastFocus = document.getElementById('cart-drawer-toggle');
    var d = drawer();
    if (d) { try { d.focus(); } catch (err) {} }
    watch();
  });

  // Escape -> close via the existing close control.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = drawer();
    if (!isOpen(d)) return;
    var close = d.querySelector('side-panel-close, .side-panel-close');
    if (close) close.click();
  });

  // Focus trap on Tab.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var d = drawer();
    if (!isOpen(d)) return;
    var f = focusables(d);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    // If focus has escaped the drawer entirely (e.g. to the page behind it),
    // Tab wouldn't hit the first/last guard below — pull it back inside.
    if (!d.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Return focus to the cart icon when the drawer closes.
  function watch() {
    var d = drawer();
    if (!d || d.__moA11yWatched) return;
    d.__moA11yWatched = true;
    new MutationObserver(function () {
      if (!d.classList.contains('active') && lastFocus) {
        try { lastFocus.focus(); } catch (err) {}
        lastFocus = null;
      }
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
